// src/confluence/whiteboard/types.ts
var ConfluenceWhiteboardAriResourceOwner = "confluence", ConfluenceWhiteboardAriResourceType = "whiteboard";

export {
  ConfluenceWhiteboardAriResourceOwner,
  ConfluenceWhiteboardAriResourceType
};
